import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { Component, ContentChildren, EventEmitter, Input, Output, } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrimeTemplate } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
let ConfirmDestructiveDialogComponent = class ConfirmDestructiveDialogComponent {
    value = '';
    show = false;
    message = '';
    title = '';
    onAccept = new EventEmitter();
    onReject = new EventEmitter();
    templates;
    headerTemplate;
    contentTemplate;
    footerTemplate;
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'header':
                    this.headerTemplate = item.template;
                    break;
                case 'content':
                    this.contentTemplate = item.template;
                    break;
                case 'footer':
                    this.footerTemplate = item.template;
                    break;
                default:
                    this.contentTemplate = item.template;
                    break;
            }
        });
    }
    accept() {
        this.onAccept.emit();
        this.show = false;
    }
    reject() {
        this.onReject.emit();
        this.show = false;
    }
    enteredValue = '';
    static propDecorators = {
        value: [{ type: Input }],
        show: [{ type: Input }],
        message: [{ type: Input }],
        title: [{ type: Input }],
        onAccept: [{ type: Output }],
        onReject: [{ type: Output }],
        templates: [{ type: ContentChildren, args: [PrimeTemplate,] }]
    };
};
ConfirmDestructiveDialogComponent = __decorate([
    Component({
        selector: 'app-confirm-destructive-dialog',
        template: `
    <p-dialog
      header="{{'Delete ' + value + '? This action is irreversible'}}"
      [(visible)]="show"
      [modal]="true"
      (onHide)="reject()"
      [style]="{ width: '50vw' }"
    >
      <ng-container *ngIf="!!headerTemplate">
        <ng-template pTemplate="header">
          <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </ng-template>
      </ng-container>

      <ng-container [ngSwitch]="!!contentTemplate">
        <ng-container *ngSwitchCase="true">
          <ng-template pTemplate="content">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-template pTemplate="content">
            <ng-container>
              <h4 class="data-item" *ngIf="!!title">{{title}}</h4>
              <div class="bg-danger p-confirm-popup-message p-20 bd-6">
                <p class="data-item" *ngIf="!!message">{{message}}</p>
                <p>Please write <strong>'{{ value }}'</strong> to confirm.</p>
                <input class="form-control input-lg" type="text" pInputText [(ngModel)]="enteredValue" />
              </div>
            </ng-container>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container [ngSwitch]="!!footerTemplate">
        <ng-container *ngSwitchCase="true">
          <ng-template pTemplate="footer">
            <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-template pTemplate="footer">
            <button
              type="button"
              pButton
              icon="pi pi-times"
              class="p-button-secondary"
              label="Cancel"
              (click)="reject()"
            ></button>
            <button
              type="button"
              [disabled]="enteredValue !== value"
              pButton
              icon="pi pi-check"
              class="p-button-danger"
              label="Delete"
              (click)="accept()"
            ></button>
          </ng-template>
        </ng-container>
      </ng-container>
    </p-dialog>
  `,
        standalone: true,
        imports: [CommonModule, FormsModule, ButtonModule, ConfirmDialogModule, DialogModule, InputTextModule],
    })
], ConfirmDestructiveDialogComponent);
export { ConfirmDestructiveDialogComponent };
